import $api from '../../utils/api.js'


const state = () => ({
    challenge: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    sorting: {
        num:10,
        search: '',
        offset: 4,
        placeholder:'Search Challenge'
    },
    formdata:{
        id:'',
        name:'',
        desc:'',
        start_date:'',
        end_date:'',
        status:'',
        achievement_type:'',
        achievement:[],
        users:[],
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.challenge = payload
    },
    ASSIGN_DATA_PARTICIPANT_RANK(state, payload) {
        state.formdata.users = Object.values(payload)
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = {
            id:payload.id,
            name:payload.name,
            desc:payload.desc,
            start_date:payload.start_date,
            end_date:payload.end_date,
            status:payload.status,
            achievement_type:payload.achievement_type,
            users:payload.users,
            achievement:payload.achievement,
        }
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            name:'',
            desc:'',
            start_date:'',
            end_date:'',
            status:'',
            achievement_type:'',
            achievement:[],
            users:[],
        },
        state.errors = []
    },
    CLEAR_PARTNER(state){
        state.challenge = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getChallenge({ commit, state }) {
        var page = state.sorting.search ? 1 : state.challenge.current_page

        return new Promise((resolve) => {
            $api.get(`challenge?page=${page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    getParticipantRank({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`participant-rank?id=${state.formdata.id}&start=${state.formdata.start_date}&end=${state.formdata.end_date}`)
            .then((response) => {
                commit('ASSIGN_DATA_PARTICIPANT_RANK', response.data)
                resolve(response.data)
            })
        })
    },
    createChallenge({ commit }, payload) {
        return new Promise((resolve) => {
            $api.post(`challenge`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    updateChallenge({ state,commit }, payload) {
        return new Promise((resolve) => {
            $api.put(`challenge/${state.formdata.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    deleteChallenge({ dispatch }, payload) {
        return new Promise((resolve) => {
            $api.delete(`challenge/${payload}`)
            .then(() => {
                dispatch('getChallenge').then(() => resolve())
            })
        })
    },
    updateChallengeParticipant({ state,commit }, payload) {
        return new Promise((resolve) => {
            $api.put(`participant-challenge/${state.formdata.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    statusChallenge({state, commit }, payload) {
        return new Promise((resolve) => {
            $api.put(`status-challenge/${payload.id}/${payload.status}`, state.formdata)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    upgradeTier({ commit }) {
        return new Promise((resolve) => {
            $api.get(`upgrade-tier`)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}